import { CModalBody } from '@coreui/react';
import styled from 'styled-components';

export const StyledModalBodyV2 = styled(CModalBody)`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap || '24px'};
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 !important;
  padding-right: 0 !important;

  &::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    display: none;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
  }

  &:hover {
    &::-webkit-scrollbar {
      width: 0;
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      display: none;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: transparent;
    }
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;
